<div class="flex-wrap">
  
  <MultiSelect 
    on:selected={e=>selected(e)}
    on:clear={e=>selectedPanels=[]}  
    selectedIds={selectedPanels}
  />
    <Icon class="green" style="pad-right: 2px;" render={Filter} on:click={e=>apply(e)} />
    <Icon class="red" style="pad-right: 2px;" render={FilterRemove} on:click={e=>selectedPanels=[]} />
    <!-- <Icon style="pad-right: 3px;" render={FilterReset} on:click={e=>selectedPanels=[]} /> -->
</div>

<style lang="scss" global>
	/** Gray 10 theme **/
	@import "carbon-components-svelte/css/g10";
  @import '@carbon/colors/scss/mixins';
  @include carbon--colors();  

.flex-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
// .green {
//   color: $green-50;
// }
// .red {
//   color: $red-50;
// }

</style>

<script>
  
  export let selectedIds 
	import { createEventDispatcher } from "svelte"
  
  import { Icon } from "carbon-components-svelte"
  import MultiSelect from './MultiSelect.svelte'
  import FilterReset from "carbon-icons-svelte/lib/FilterReset24"
  import FilterRemove from "carbon-icons-svelte/lib/FilterRemove24"
  import Filter from "carbon-icons-svelte/lib/Filter24"

	const dispatch = createEventDispatcher()

  let selectedPanels = selectedIds

  const selected = (e) => {
    selectedPanels = e.detail
  }
  const apply = (e) => {
		dispatch('filterPanels',selectedPanels)
	}

</script>